import { render, staticRenderFns } from "./TicketListItem.vue?vue&type=template&id=32631088&scoped=true&"
import script from "./TicketListItem.vue?vue&type=script&lang=js&"
export * from "./TicketListItem.vue?vue&type=script&lang=js&"
import style0 from "./TicketListItem.vue?vue&type=style&index=0&id=32631088&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32631088",
  null
  
)

export default component.exports